import React from 'react';
import { Link } from 'react-router-dom';
import { ListGroup, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestion, faCalendar } from '@fortawesome/free-solid-svg-icons';
import { format } from 'date-fns';
import { getIconFromString } from '../../utils/iconUtils';
import PaymentStatusBadge from '../common/PaymentStatusBadge';

const RecentExpenses = ({ expenses }) => {
  if (!expenses || expenses.length === 0) {
    return (
      <div className="empty-state text-center py-4">
        <p className="text-muted mb-3">No expenses yet. Add your first one to get started.</p>
        <Link to="/expenses/new" className="btn btn-primary">
          Add Expense
        </Link>
      </div>
    );
  }

  const getSplitMethodLabel = (splitMethod) => {
    if (splitMethod === 'percentage' || splitMethod === 'equal' || splitMethod === 'none' || splitMethod === 'full') {
      switch (splitMethod) {
        case 'percentage':
          return { text: 'Salary %', tone: 'primary' };
        case 'equal':
          return { text: '50/50', tone: 'info' };
        case 'full':
          return { text: '100% reclaim', tone: 'success' };
        case 'none':
          return { text: 'No Split', tone: 'secondary' };
        default:
          return { text: 'Unknown', tone: 'warning' };
      }
    }

    switch (splitMethod) {
      case 'SALARY_PERCENTAGE':
        return { text: 'Salary %', tone: 'primary' };
      case 'FIFTY_FIFTY':
        return { text: '50/50', tone: 'info' };
      case 'FULL_RECLAIM':
        return { text: '100% reclaim', tone: 'success' };
      case 'NO_REIMBURSEMENT':
        return { text: 'No Split', tone: 'secondary' };
      default:
        return { text: 'Unknown', tone: 'warning' };
    }
  };

  return (
    <ListGroup variant="flush" className="recent-expenses-list">
      {expenses.map((expense) => {
        const splitLabel = getSplitMethodLabel(expense.splitMethod || expense.splitType);
        const categoryData = expense.Category || expense.category;

        return (
          <ListGroup.Item
            key={expense.id}
            action
            as={Link}
            to={`/expenses/${expense.id}`}
            className="recent-expense-item d-flex justify-content-between align-items-center py-3"
          >
            <div className="d-flex align-items-center min-w-0">
              <div
                className="category-chip me-3"
                style={{
                  backgroundColor: `${categoryData?.color || '#9E9E9E'}22`,
                  color: categoryData?.color || '#9E9E9E',
                }}
              >
                <FontAwesomeIcon icon={getIconFromString(categoryData?.icon, faQuestion)} />
              </div>
              <div className="min-w-0">
                <div className="fw-semibold text-truncate">{expense.title}</div>
                <div className="small text-muted">
                  <div>{format(new Date(expense.date), 'MMM d, yyyy')}</div>
                  {new Date(expense.date) > new Date() && (
                    <Badge bg="info" className="mt-1 mb-1">
                      <FontAwesomeIcon icon={faCalendar} className="me-1" />
                      Future
                    </Badge>
                  )}
                  <div className="text-truncate">{categoryData?.name || 'Uncategorized'}</div>
                </div>
              </div>
            </div>
            <div className="text-end ms-3 flex-shrink-0">
              <div className="fw-semibold money-figure">
                £
                {expense.amount != null && !isNaN(expense.amount)
                  ? parseFloat(expense.amount).toFixed(2)
                  : '0.00'}
              </div>
              <div className="d-flex align-items-center justify-content-end gap-1 flex-wrap mt-1">
                <PaymentStatusBadge expense={expense} showRemaining />
                <Badge bg={splitLabel.tone} pill className="split-badge">
                  {splitLabel.text}
                </Badge>
              </div>
            </div>
          </ListGroup.Item>
        );
      })}
    </ListGroup>
  );
};

export default RecentExpenses;
